import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, Checkbox, Form, Input, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useAPIPublic, useSecurity } from "../../tools/api";
import { commaDigits, convertCurrencyToRial, convertCurrencyToToman, convertToJalaliWithTime, delay, isEmpty } from "../../tools/tools";
import { globalValue } from "../../reducer/serviceReducerGlobala";
import Loading from "../loader/loading";
import styles from "./InCreaseWallet.module.scss";
const InCreaseWallet = ({ callback, open, msisdn, planid, price, localInvoiceId = "", activePrice = false }) => {
  const [disInput, setDisInput] = useState(true);

  const [statusOpen, setStatusOpen] = useState(open || false);
  const dispatch = useDispatch();
  const { queryWalletType } = useAPIPublic();
  const { queryGateWayByPlanId, increaseWalletByBankGateWay, callBackIPGAsanPardakht } = useSecurity();
  const { queryCurrentUser } = useAPIPublic();
  const [t] = useTranslation("global");
  const [listWallet, setListWallet] = useState([]);
  const [chargeAmount, setChargeAmount] = useState();
  const [bankId, setBankId] = useState(0);
  const [frmCharge] = Form.useForm();
  const [isCallBack, setIsCallback] = useState(false);
  const [floLocalInvoiceId, setFloLocalInvoiceId] = useState("");
  const [bankMessage, setBankMessage] = useState();
  const [bankTitle, setBankTitle] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const { _currentUser } = useSelector((state) => {
    return state?.another;
  });
  useEffect(() => {
    if (open) {
      setStatusOpen(open);
      if (isEmpty(localInvoiceId)) {
        handleLoadWalletType();
        handleGetWay();
        setIsCallback(false);
      } else {
        setIsCallback(true);
        setFloLocalInvoiceId(localInvoiceId);
        handelCallBankBank(localInvoiceId);
      }
    }
  }, [open]);
  useEffect(() => {
    setChargeAmount(price);
    frmCharge.setFieldValue("charge", commaDigits(convertCurrencyToToman(price)));
  }, [price]);
  const handleComma = (e) => {
    let v = e.target.value;
    if (e.target.value.length > 0 && !isNaN(parseInt(e.target.value))) {
      v = commaDigits(parseInt(e.target.value.replace(/,/g, "")) / 1);
      e.target.value = v;
      return v;
    } else {
      return "";
    }
  };
  const handleSubmit = async (value) => {
    let payload = {
      Amount: convertCurrencyToRial(value.charge.replace(/,/g, "")),
      PlanId: planid,
      WalletType: listWallet.value,
      BnakId: bankId,
    };
    let response = await increaseWalletByBankGateWay(payload);
    if (response) {
      callback(response);
    }
  };
  const handleLoadWalletType = async () => {
    try {
      setIsLoading(true);
      let response = await queryWalletType();
      if (response) {
        const filterType = response.find((item) => item.value === 1);
        setListWallet(filterType);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleGetWay = async () => {
    setIsLoading(true);
    let payload = {
      msisdn: msisdn,
      planid: planid,
    };
    let response = await queryGateWayByPlanId(payload);
    if (response) {
      setBankId(response[0]?.bankId);
    }
    setIsLoading(false);
  };
  const handelCallBankBank = async (LocalInvoiceId) => {
    setIsLoading(true);
    let payload = {
      LocalInvoiceId: LocalInvoiceId,
    };
    let response = await callBackIPGAsanPardakht(payload);
    if (response && !response?.HasError) {
      setFloLocalInvoiceId(response?.Result?.followupcode);
      setBankTitle("پرداخت موفق");
      setBankMessage(response?.Message);
      await delay(3000);
      let _currentUser = await queryCurrentUser();
      if (!_currentUser.HasError) {
        dispatch(globalValue({ _currentUser: { ..._currentUser.Result } }));
      }
    } else {
      setBankTitle("پرداخت ناموفق");
      setBankMessage(response?.Message);
      setFloLocalInvoiceId(response?.Result?.followupcode);
    }
    setIsLoading(false);
  };
  return (
    <>
      <Modal
        centered
        width="25rem"
        closeIcon={<CloseCircleOutlined />}
        open={statusOpen}
        footer={<></>}
        onCancel={() => {
          setStatusOpen(false);
          callback(null);
        }}
      >
        {isCallBack ? (
          <div className={styles.holder_callback}>
            <h3>{bankTitle}</h3>
            <p>{bankMessage}</p>
            <div className={styles.holder_list_pay}>
              <ul>
                <li>
                  <div className={styles.label}>تاریخ و ساعت</div>
                  <div className={styles.value}>{convertToJalaliWithTime(new Date().toISOString())}</div>
                </li>
                <li>
                  <div className={styles.label}>کدپیگیری</div>
                  <div className={styles.value}>{localInvoiceId}</div>
                </li>
              </ul>
            </div>
            <div className="holder-button">
              <Button
                className={`${styles.btn_prev} btn-normal`}
                onClick={() => {
                  setStatusOpen(false);
                  callback(false);
                }}
              >
                بازگشت
              </Button>
            </div>
          </div>
        ) : (
          <div className={styles.holder_incress_wallet}>
            <h3>افزایش اعتبار</h3>

            <Form form={frmCharge} onFinish={handleSubmit} layout="vertical">
              <Form.Item
                rules={[
                  { required: true, message: t("validation.required") },
                  {
                    validator: (_, value) => {
                      let _regex = new RegExp(t("validation.regexDigitComma"));
                      if (!_regex.test(value)) {
                        return Promise.reject(t("validation.number"));
                      }
                      return Promise.resolve();
                    },
                  },
                  {
                    validator: (_, value) => {
                      let amount = parseInt(value.replace(/,/g, ""));
                      if (
                        amount % parseInt(process.env.REACT_APP_MIN_CHARGE_BANK) === 0 &&
                        amount >= parseInt(process.env.REACT_APP_MIN_CHARGE_BANK)
                      ) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(t("validation.charge_bank_min"));
                      }
                    },
                  },
                ]}
                name="charge"
                label="مبلغ شارژ"
              >
                <Input onInput={handleComma} dir="ltr" addonAfter="تومان" placeholder="مبلغ دلخواه" disabled={!activePrice ? disInput : false} />
              </Form.Item>
              {!activePrice && (
                <Form.Item label="مبلغ دلخواه" className="label-check">
                  <Checkbox className="just-check" onChange={(e) => (e.target.checked === true ? setDisInput(false) : setDisInput(true))} />
                </Form.Item>
              )}

              <br />
              <Form.Item>
                <div className="holder-button">
                  <Button className={`${styles.btn_charge} btn-aptel`} danger htmlType="submit" type="primary">
                    پرداخت
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>
        )}
      </Modal>
      <Loading isOpen={isLoading} />
    </>
  );
};

export default InCreaseWallet;
